<footer class="pb-0">
  <div class="page__content">
    <div class="w-100">
      <div class="row footer-main-row" style="margin-top: 1rem; margin-bottom: 3rem">
        <div class="col-12 col-md-3 logo_footer_div" >
          <a *ngIf="footerWebUrl" [href]="footerWebUrl" target="_blank" rel="noopener" [title]="'FOOTER.WEB_TITLE' | translate" class="logo_mtop">
            <img
              [src]="logoFooterUrl"
              [alt]="'FOOTER.WEB_TITLE' | translate"
              class="logo_footer"
            />
          </a>
          <img
            *ngIf="!footerWebUrl"
            [src]="logoFooterUrl"
            [alt]="'FOOTER.WEB_TITLE' | translate"
            class="logo_footer logo_mtop"
          />
        </div>
        <div class="col-12 col-sm-8">
          <div class="redes" [class.redes--no-social]="!showSocial">
            <small *ngIf="showSocial">{{ 'FOOTER.FOLLOW' | translate }}</small>
            <a *ngIf="showSocial && socialTwitter" [href]="socialTwitter" style="margin-left: 1em" target="_blank" rel="noopener">
              <img [src]="clientLoader.getAssetUrl('/assets/emvs/social/icoX.png')" alt="" class="icons" />
            </a>
            <a *ngIf="showSocial && socialInstagram" [href]="socialInstagram" target="_blank" rel="noopener">
              <img [src]="clientLoader.getAssetUrl('/assets/emvs/social/icoInstagram.png')" alt="" class="icons" />
            </a>
            <a *ngIf="showSocial && socialYoutube" [href]="socialYoutube" class="youtube" target="_blank" rel="noopener">
              <img [src]="clientLoader.getAssetUrl('/assets/emvs/social/icoYouTube.png')" alt="" class="icons" />
            </a>
            <a *ngIf="showSocial && socialLinkedin" [href]="socialLinkedin" target="_blank" rel="noopener">
              <img [src]="clientLoader.getAssetUrl('/assets/emvs/social/icoLinkedIn.png')" alt="" class="icons" />
            </a>
            <a *ngIf="showSocial && socialRss" [href]="socialRss" target="_blank" rel="noopener">
              <img [src]="clientLoader.getAssetUrl('/assets/emvs/social/icoRSS.png')" alt="" class="icons" />
            </a>
            <div class="footer-legal">
              <p class="organization">
                {{ 'FOOTER.COPYRIGHT' | translate: { year: date } }}
              </p>
              <div class="mt-4 mb-4 footer-legal-links">
                <a class="btn-info-legal pointer mr-3" (click)="recuperaUrlConcacto()">{{ 'FOOTER.CONTACT' | translate }}</a>
                <a class="btn-info-legal mr-3" routerLink="/info/aviso-legal">{{ 'FOOTER.LEGAL' | translate }}</a>
                <a
                  *ngIf="footerTermsUrl"
                  class="btn-info-legal mr-3"
                  [href]="footerTermsUrl"
                  target="_blank"
                  rel="noopener"
                >{{ 'FOOTER.TERMS' | translate }}</a>
                <a class="btn-info-legal mr-3" routerLink="/info/politica-privacidad">{{ 'FOOTER.PRIVACY' | translate }}</a>
              </div>
              <address>
                <small>{{ 'FOOTER.ADDRESS' | translate }}</small>
              </address>
            </div>
            <div *ngIf="footerCertImage">
              <a
                [href]="footerCertUrl || '#'"
                title="Carta de servicios"
                [attr.target]="footerCertUrl ? '_blank' : null"
                [attr.rel]="footerCertUrl ? 'noopener' : null"
              >
                <img
                  class="aenor"
                  [alt]="'FOOTER.AENOR_ALT' | translate"
                  [src]="footerCertImage"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
